import { motion } from "framer-motion";
import { ease } from "./constants";

export const Reveal = ({ children, delay = 0, y = 36, className = "", as = "div" }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </Comp>
  );
};

export const Eyebrow = ({ children, dark = false }) => (
  <p className={`font-mono-x text-xs uppercase tracking-[0.3em] flex items-center gap-3 ${dark ? "text-[#0c0a09]" : "text-[#FACC15]"}`}>
    <span className={`h-px w-10 ${dark ? "bg-[#0c0a09]" : "bg-[#FACC15]"}`} />
    {children}
  </p>
);
